angular.module('impactx.product').controller('NewProductsCtrl', ['$scope', 'dataGen', NewProductsCtrl]);

function NewProductsCtrl($scope, dataGen) {
    dataGen.getData($scope, {}, '/product/newproducts');
}